// packages block
import { useEffect, useRef, useState } from "react";
import Lottie from "lottie-react";
import Pdf from "react-to-pdf";
import "./components/style.css";
import { useHistory } from "react-router";
import { Controller, useForm } from "react-hook-form";
import ReactPhoneInput from "react-phone-input-2";
import ReCAPTCHA from "react-google-recaptcha";
import "react-phone-input-2/lib/material.css";
import tickIconAnimation from "../../assets/video/tick-icon.json";
import {
  Box,
  Typography,
  Container,
  Grid,
  TextField,
  Button,
  CircularProgress,
} from "@material-ui/core";
// components block
import {
  sendOtpForCashlessPaymentReceipt,
  verifyOtpForCashlessPaymentReceipt,
} from "../../api/auth";
import { setAlert } from "../../redux/reducers/alert";
import { BLACK_SEVEN, BLUE_EIGHT, GREEN_ONE, WHITE } from "../../theme";
import { useDispatch } from "react-redux";
import OtpInput from "react-otp-input";
import { ReCAPTCHA_SITE_KEY } from "../../util/constants";
import backButtonIcon from "../../assets/images/back-button-icon.png";
import logoImg from "../../assets/images/logo-v1.png";
import { useLocation } from "react-router";
import { Error } from "@material-ui/icons";
import { getTransactionByOrderId } from "../../api/transactions";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const NotificationForPaymentLink = () => {
  const [recaptchaResponse, setRecaptchaResponse] = useState("");
  const [receiptId, setReceiptId] = useState(null);
  const [isVerifyOtp, setIsVerifyOtp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paidAmount, setPaidAmount] = useState(0);
  const [payeeType, setPayeeType] = useState(0);
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [transactionLoading, setTransactionLoading] = useState(false);
  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    setValue,
    watch,
  } = useForm();
  const history = useHistory();
  const parentReceiptRef = useRef(null);
  const [otp, setOtp] = useState("");
  const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  const [showTimer, setShowTimer] = useState(true);
  const [seconds, setSeconds] = useState(30);
  const [timerValue, setTimerValue] = useState(`00:${seconds}`);
  const dispatch = useDispatch();
  const [currentEmail, setCurrentEmail] = useState(null);
  const [currentPhoneNumber, setCurrentPhoneNumber] = useState(null);

  const paymentStatus = useQuery().get("status");
  const paymentMessage = useQuery().get("message");
  const paymentOrderId = useQuery().get("orderId");

  const obscureEmail = (email) => {
    const [name, domain] = email.split("@");
    return `${name[0]}${new Array(name.length).join("*")}@${domain}`;
  };

  const obscurePhoneNumber = (number) => {
    let trailingCharsIntactCount = 4;
    const num =
      new Array(number.length - trailingCharsIntactCount + 1).join("*") +
      number.slice(-trailingCharsIntactCount);
    return num;
  };

  const formatReceiptAmount = (amount) => {
    const numericAmount = Number(amount || 0);
    return `AED ${new Intl.NumberFormat("en-US").format(numericAmount)}`;
  };

  const formatReceiptDate = (value) => {
    if (!value) return "-";

    const parsedDate = new Date(value);

    if (Number.isNaN(parsedDate.getTime())) {
      return "-";
    }

    const month = parsedDate.toLocaleString("en-US", { month: "long" });
    return `${String(parsedDate.getDate()).padStart(2, "0")} - ${month} - ${parsedDate.getFullYear()}`;
  };

  const otpInputStyle = {
    height: 55,
    width: 55,
    fontSize: 25,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderBottomColor: BLUE_EIGHT,
    color: BLUE_EIGHT,
  };

  const otpInputFocus = {
    background: "white",
    color: BLUE_EIGHT,
  };

  const onOtpChange = (e) => {
    setOtp(e);
  };

  const showErrorAlert = (message) => {
    if (!message) message = "Something went wrong";
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };

  const mobileNumber = watch("mobileNumber");
  let customMobileNumber;

  const onSubmit = async (data) => {
    const { email, countryCode, mobileNumber } = data || {};

    customMobileNumber = mobileNumber.substring(
      countryCode?.length,
      mobileNumber?.length
    );
    if (email) {
      setCurrentEmail(email);
    }

    if (mobileNumber) {
      setCurrentPhoneNumber(mobileNumber);
    }
    setLoading(true);
    const payload = {
      email,
      countryCode: `+${countryCode}`,
      phoneNumber: customMobileNumber,
      rcResponse: recaptchaResponse,
      orderId: paymentOrderId ?? null,
    };
    const response = await sendOtpForCashlessPaymentReceipt(payload);
    if (response.status) {
      showSuccessAlert(response.message);
      setLoading(false);
      setReceiptId(response?.receipt?.id);
      setIsVerifyOtp(true);
    } else {
      showErrorAlert(response.message);
      setLoading(false);
    }
  };

  const handleOnChange = (value, country) => {
    setValue("mobileNumber", value.replace(/\D/g, ""));
    setValue("countryCode", country.dialCode);
  };

  const onChange = (value) => {
    setRecaptchaResponse(value);
  };

  const handleVerifyOtp = async () => {
    if (otp.length < 1) {
      showErrorAlert("Please enter your otp");
    }

    const payload = {
      receiptId,
      otp,
    };
    const response = await verifyOtpForCashlessPaymentReceipt(payload);
    if (response.type === "success") {
      showSuccessAlert(response?.message);
      setIsSuccessMessage(true);
    } else {
      showErrorAlert(response?.message);
    }
  };
  const schoolId = localStorage.getItem("schoolId");
  const transactionParentName =
    transactionDetails?.parentName ||
    [transactionDetails?.parent?.firstName, transactionDetails?.parent?.lastName]
      .filter(Boolean)
      .join(" ") ||
    [transactionDetails?.student?.firstName, transactionDetails?.student?.lastName]
      .filter(Boolean)
      .join(" ") ||
    "-";
  const transactionFamilyAccountNumber =
    transactionDetails?.parentRegNo ||
    transactionDetails?.payeeId ||
    transactionDetails?.student?.parentRegNo ||
    "-";
  const transactionSchoolName =
    transactionDetails?.school?.name ||
    transactionDetails?.student?.school?.name ||
    "-";
  const transactionDate = formatReceiptDate(
    transactionDetails?.payedOn
  );
  const isParentPayee =
    payeeType?.toString()?.toLowerCase() === "parent";
  const parentReceiptFileName = `Payment-Receipt-${paymentOrderId || "receipt"}.pdf`;

  useEffect(() => {
    let interval;
    if (showTimer && isSuccessMessage) {
      setTimeout(() => {
        setShowTimer(false);
      }, 36000);
      interval = setInterval(() => {
        if (seconds === 0) {
          clearInterval(interval);
        }
        setSeconds((seconds) => seconds - 1);
        setTimerValue(`00:${seconds}`);
        setSeconds(seconds - 1);
      }, 1000);
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isSuccessMessage, seconds, showTimer]);

  useEffect(() => {
    if (paymentOrderId) {
      setTransactionLoading(true);
      getTransactionByOrderId(paymentOrderId).then((res) => {
        if (res.status) {
          setTransactionDetails(res?.transaction ?? null);
          setPaidAmount(res?.transaction?.amount ?? 0);
          setPayeeType(res?.transaction?.school?.payeeType ?? "");
        }
        setTransactionLoading(false);
      });
    } else {
      setTransactionLoading(false);
    }
  }, [paymentOrderId]);

  useEffect(() => {
    if (timerValue === "00:0") {
      history?.push(`/paymentLink/${schoolId}`);
    }
  }, [history, schoolId, timerValue]);

  return (
    <div className="main-conatiner">
      {paymentStatus === "false" ? (
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          width="100vw"
          height="100vh"
        >
          <Container maxWidth="sm">
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              borderRadius="33px"
              boxShadow=" 0px 3px 6px #00000029"
              position="relative"
              style={{ backgroundColor: WHITE, padding: 50 }}
            >
              <Box textAlign="center">
                <Box display="flex" justifyContent="center">
                  <Error style={{ color: "red", fontSize: 80 }} />
                </Box>

                <Typography
                  variant="h3"
                  style={{
                    marginBottom: 20,
                    marginTop: 20,
                    fontWeight: 700,
                    fontSize: 32,
                    color: "red",
                  }}
                >
                  {paymentMessage ?? "Payment Message Error"}
                </Typography>

                <Button
                  onClick={() => history?.push(`/paymentLink/${schoolId}`)}
                  style={{
                    borderRadius: "20px",
                    backgroundColor: BLUE_EIGHT,
                    color: "white",
                    maxWidth: "250px",
                    width: "100%",
                    marginTop: 20,
                    height: 46,
                  }}
                  variant="contained"
                  color="primary"
                >
                  Home
                </Button>
              </Box>
            </Box>
          </Container>
        </Box>
      ) : transactionLoading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100vw"
          height="100vh"
        >
          <CircularProgress style={{ color: BLUE_EIGHT }} />
        </Box>
      ) : (
        isParentPayee ? (
          <Box
            display="flex"
            justifyContent="center"
            flexDirection="column"
            width="100vw"
            height="100vh"
          >
            <Container maxWidth="md">
              <Box width="100%" display="flex" justifyContent="center">
              <Box
                ref={parentReceiptRef}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                borderRadius="33px"
                boxShadow="0px 3px 16px #00000029"
                position="relative"
                style={{
                  backgroundColor: WHITE,
                  padding: "36px 34px 30px",
                  width: "100%",
                  maxWidth: 760,
                  margin: "0 auto",
                }}
              >
                <Box width="100%" textAlign="center">
                  <Box mb={2} display="flex" justifyContent="center">
                    <img
                      src={logoImg}
                      alt="paynest-logo"
                      style={{ maxWidth: 230, width: "100%" }}
                    />
                  </Box>

                  <Typography
                    variant="body1"
                    style={{
                      color: BLACK_SEVEN,
                      fontSize: 20,
                      fontWeight: 500,
                      marginBottom: 20,
                    }}
                  >
                    Payment Receipt
                  </Typography>

                  <Typography
                    variant="h4"
                    style={{
                      color: BLACK_SEVEN,
                      fontSize: 22,
                      fontWeight: 700,
                      lineHeight: 1.4,
                      marginBottom: 26,
                    }}
                  >
                    {transactionSchoolName}
                  </Typography>

                  <Box width="100%" mb={3}>
                    {[
                      {
                        label: "Parent Name",
                        value: transactionParentName,
                      },
                      {
                        label: "Family Account Number",
                        value: transactionFamilyAccountNumber,
                      },
                      {
                        label: "School Name",
                        value: transactionSchoolName,
                      },
                      {
                        label: "Date",
                        value: transactionDate,
                      },
                    ].map((item) => (
                      <Box
                        key={item.label}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        py={2}
                        style={{
                          borderBottom: "1px solid #E2E2E2",
                          gap: 16,
                        }}
                      >
                        <Typography
                          variant="body1"
                          style={{
                            color: BLACK_SEVEN,
                            fontWeight: 700,
                            fontSize: 18,
                            textAlign: "left",
                          }}
                        >
                          {item.label}
                        </Typography>

                        <Typography
                          variant="body1"
                          style={{
                            color: "#5E5E5E",
                            fontWeight: 600,
                            fontSize: 18,
                            textAlign: "right",
                            wordBreak: "break-word",
                          }}
                        >
                          {item.value}
                        </Typography>
                      </Box>
                    ))}
                  </Box>

                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    width="100%"
                    px={3}
                    py={2}
                    style={{
                      backgroundColor: "#1DD1C1",
                      borderRadius: 12,
                    }}
                  >
                    <Typography
                      variant="body1"
                      style={{
                        color: BLACK_SEVEN,
                        fontWeight: 700,
                        fontSize: 20,
                      }}
                    >
                      Fee Paid
                    </Typography>

                    <Typography
                      variant="body1"
                      style={{
                        color: BLACK_SEVEN,
                        fontWeight: 700,
                        fontSize: 20,
                      }}
                    >
                      {formatReceiptAmount(paidAmount)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              </Box>

              <Pdf
                filename={parentReceiptFileName}
                options={{ orientation: "portrait", unit: "px" }}
                scale={1}
                targetRef={parentReceiptRef}
                x={0}
                y={0}
              >
                {({ toPdf }) => (
                  <Button
                    onClick={toPdf}
                    style={{
                      borderRadius: "14px",
                      backgroundColor: BLUE_EIGHT,
                      color: WHITE,
                      width: "100%",
                      height: 52,
                      fontSize: 20,
                      fontWeight: 500,
                      textTransform: "none",
                      marginTop: 20,
                    }}
                    variant="contained"
                  >
                    Download Receipt
                  </Button>
                )}
              </Pdf>
            </Container>
          </Box>
        ) : (
          <>
            {isVerifyOtp && !isSuccessMessage && (
              <div
                style={{
                  backgroundColor: "transparent",
                  height: 30,
                  width: 30,
                  borderRadius: 5,
                  cursor: "pointer",
                  position: "absolute",
                  top: "2%",
                  left: "2%",
                }}
                role="presentation"
                onClick={() => setIsVerifyOtp(false)}
              >
                <img
                  src={backButtonIcon}
                  style={{ width: 40 }}
                  alt="back-button-icon"
                />
              </div>
            )}
            <Box
              display="flex"
              justifyContent="center"
              flexDirection="column"
              width="100vw"
              height="100vh"
            >
              <Container maxWidth="sm">
                {isSuccessMessage ? (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    borderRadius="33px"
                    boxShadow=" 0px 3px 6px #00000029"
                    position="relative"
                    style={{ backgroundColor: WHITE, padding: 50 }}
                  >
                    <Box textAlign="center">
                      <Box display="flex" justifyContent="center">
                        <Lottie
                          animationData={tickIconAnimation}
                          style={{ width: 150 }}
                          loop={true}
                        />
                      </Box>

                      <Typography
                        variant="h3"
                        style={{
                          marginBottom: 20,
                          marginTop: 20,
                          fontWeight: 700,
                          fontSize: 32,
                          color: BLACK_SEVEN,
                        }}
                      >
                        THANK YOU!
                      </Typography>

                      <Typography
                        variant="h6"
                        style={{
                          marginBottom: 10,
                          fontSize: 21,
                          color: BLACK_SEVEN,
                        }}
                      >
                        YOUR RECEIPT HAS BEEN FORWARDED TO YOUR GIVEN DETAILS
                      </Typography>

                      <Typography
                        variant="body2"
                        style={{
                          marginLeft: 8,
                          marginBottom: 20,
                          fontSize: 16,
                          fontWeight: 500,
                          width: "100%",
                          color: "darkgray",
                        }}
                      >
                        {showTimer && (
                          <p className="" style={{ cursor: "text" }}>
                            {timerValue}
                          </p>
                        )}
                      </Typography>

                      <Button
                        onClick={() => history?.push(`/paymentLink/${schoolId}`)}
                        style={{
                          borderRadius: "20px",
                          backgroundColor: BLUE_EIGHT,
                          color: "white",
                          maxWidth: "250px",
                          width: "100%",
                          marginTop: 20,
                          height: 46,
                        }}
                        variant="contained"
                        color="primary"
                      >
                        Done
                      </Button>
                    </Box>
                  </Box>
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    borderRadius="33px"
                    boxShadow=" 0px 3px 6px #00000029"
                    position="relative"
                    style={{ backgroundColor: WHITE, padding: 50 }}
                  >
                    <Box textAlign="center" mb={5}>
                      <Box display="flex" justifyContent="center">
                        <Lottie
                          animationData={tickIconAnimation}
                          style={{ width: 150 }}
                          loop={true}
                        />
                      </Box>

                      <Typography
                        variant="h3"
                        style={{
                          marginBottom: 30,
                          marginTop: 10,
                          fontWeight: 700,
                          fontSize: 32,
                          color: BLACK_SEVEN,
                        }}
                      >
                        SUCCESS
                      </Typography>

                      {!isVerifyOtp && (
                        <>
                          <Typography
                            variant="body2"
                            style={{
                              fontSize: 28,
                              fontWeight: 700,
                              color: GREEN_ONE,
                            }}
                          >
                            AED {paidAmount}
                          </Typography>

                          <Typography
                            variant="body2"
                            style={{
                              marginBottom: 30,
                              fontSize: 16,
                              color: "darkgray",
                            }}
                          >
                            Fee Paid Successfully
                          </Typography>

                          <Typography
                            variant="body2"
                            style={{
                              marginBottom: 20,
                              fontSize: 16,
                              fontWeight: 700,
                              maxWidth: 300,
                              width: "100%",
                            }}
                          >
                            ENTER PHONE NUMBER OR EMAIL TO GET YOUR FEE RECEIPT
                          </Typography>
                        </>
                      )}
                    </Box>
                    {!isVerifyOtp && (
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={4}>
                          <Grid
                            item
                            xs={12}
                            display="flex"
                            flexDirection="column"
                            alignItems="flex-start"
                          >
                            <Controller
                              control={control}
                              name="mobileNumber"
                              defaultValue=""
                              render={({ field }) => (
                                <ReactPhoneInput
                                  containerClass="custom-phone-input"
                                  inputProps={{
                                    required: true,
                                  }}
                                  inputStyle={{
                                    width: "inherit",
                                    height: "65px",
                                    borderRadius: 10,
                                    fontFamily: "Montserrat",
                                  }}
                                  {...register("mobileNumber", {
                                    required: "Phone number is required",
                                  })}
                                  country={"ae"}
                                  specialLabel={"Phone Number"}
                                  value={field.value}
                                  onChange={(value, country) => {
                                    field.onChange(value);
                                    handleOnChange(value, country);
                                  }}
                                />
                              )}
                            />

                            {errors.mobileNumber && (
                              <Typography
                                component="span"
                                style={{ color: "red", fontSize: "10px" }}
                              >
                                {errors.mobileNumber.message}
                              </Typography>
                            )}

                            <input
                              type="hidden"
                              name="countryCode"
                              value={mobileNumber?.split(" ")[0]}
                              ref={register("countryCode", { required: true })}
                            />
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            display="flex"
                            flexDirection="column"
                            alignItems="flex-start"
                          >
                            <Controller
                              render={({ field }) => (
                                <TextField
                                  InputLabelProps={{ shrink: true }}
                                  label="Email Address"
                                  type="text"
                                  id="email"
                                  name="email"
                                  variant="outlined"
                                  fullWidth
                                  {...field}
                                />
                              )}
                              name="email"
                              control={control}
                            />
                          </Grid>
                        </Grid>
                        <Box
                          display="flex"
                          justifyContent="center"
                          py={2}
                          maxWidth={{ xs: "260px", sm: "300px" }}
                          width="100%"
                          mx="auto"
                        >
                          <ReCAPTCHA
                            sitekey={ReCAPTCHA_SITE_KEY}
                            onChange={onChange}
                          />
                        </Box>

                        <Box display="flex" justifyContent="center">
                          <Button
                            disabled={loading}
                            style={{
                              borderRadius: "20px",
                              backgroundColor: BLUE_EIGHT,
                              color: "white",
                              maxWidth: "250px",
                              width: "100%",
                              height: 46,
                            }}
                            type="submit"
                            variant="contained"
                            color="primary"
                          >
                            {loading ? (
                              <Box display="flex" alignItems="center">
                                <Typography component="span">
                                  <CircularProgress
                                    size={20}
                                    style={{ color: "white", mx: 1 }}
                                  />
                                </Typography>
                              </Box>
                            ) : (
                              <span>Send Otp</span>
                            )}
                          </Button>
                        </Box>
                      </form>
                    )}

                    {isVerifyOtp && (
                      <Box
                        display="flex"
                        flexDirection="column"
                        mt={4}
                        mb={2}
                        alignItems="center"
                        textAlign="center"
                      >
                        <Typography
                          variant="body2"
                          style={{
                            fontSize: 24,
                            fontWeight: 700,
                            maxWidth: 400,
                            width: "100%",
                            color: BLACK_SEVEN,
                          }}
                        >
                          OTP Confirmation
                        </Typography>

                        <Typography
                          variant="body2"
                          style={{
                            marginBottom: 20,
                            fontSize: 20,
                            fontWeight: 700,
                            maxWidth: 400,
                            width: "100%",
                            color: BLACK_SEVEN,
                          }}
                        >
                          {`A 6 digit code has been sent to your Email address ${currentEmail ? obscureEmail(currentEmail) : ""
                            } and Phone number ${currentPhoneNumber
                              ? obscurePhoneNumber(currentPhoneNumber)
                              : ""
                            }`}
                        </Typography>

                        <OtpInput
                          value={otp}
                          numInputs={6}
                          separator={<div style={{ width: 10 }}></div>}
                          inputStyle={otpInputStyle}
                          focusStyle={otpInputFocus}
                          isInputNum={true}
                          onChange={onOtpChange}
                        />

                        <Button
                          onClick={handleVerifyOtp}
                          style={{
                            borderRadius: "20px",
                            backgroundColor: BLUE_EIGHT,
                            color: "white",
                            maxWidth: "250px",
                            width: "100%",
                            margin: "20px 0px",
                            height: 46,
                          }}
                          type="submit"
                          variant="contained"
                          color="primary"
                        >
                          Done
                        </Button>
                      </Box>
                    )}

                    <Button
                      onClick={() => history?.push(`/paymentLink/${schoolId}`)}
                      style={{
                        borderRadius: "20px",
                        backgroundColor: "darkgray",
                        color: "white",
                        maxWidth: "250px",
                        width: "100%",
                        marginTop: isVerifyOtp ? 0 : 20,
                        height: 46,
                      }}
                      variant="contained"
                      color="primary"
                    >
                      Home
                    </Button>
                  </Box>
                )}
              </Container>
            </Box>
          </>
        )
      )}
    </div>
  );
};

export default NotificationForPaymentLink;
